module.exports = __webpack_public_path__ + "static/action-hour.4aa8fa46.png";